import React, {useContext, useEffect, useState} from "react";
import {Context} from "../../../App";
import {useTranslation} from "react-i18next";
import ModalWindow from "../../modal";
import {Link, Outlet, useNavigate, useSearchParams} from "react-router-dom";
import {Breadcrumb, Button, Col, Collapse, DatePicker, Form, Row, Space, Table} from "antd";
import moment from "moment";

import {FilterOutlined, ReloadOutlined, SearchOutlined, WarningTwoTone} from "@ant-design/icons";
import axios from "axios";
import {isNullForm} from "../../tech/check";
import DB_LogMobile from "../../../database/development/log_mobile";
import {DebounceSelect} from "../../tech/search_input";
import DB_OrgStructure from "../../../database/dictionary/org_structures";
import NextButton from "../../tech/next_button";


const LogsMobiles = () => {
    const {token, user, defaultPageSize, setToken} = useContext(Context);
    const {getLogsMobile} = DB_LogMobile(token);
    const {getOrgStructureFilter} = DB_OrgStructure(token)
    const navigate = useNavigate();
    const p = new URLSearchParams(window.location.search)
    const controller = new AbortController();

    const {t} = useTranslation();
    const {errorConnect} = ModalWindow();
    const [searchParams, setSearchParams] = useSearchParams({});
    const [search, setSearch] = useState({});
    const [wait, setWait] = useState(false);
    const [countFilters, setCountFilters] = useState(0)


    const [showFilters, setShowFilters] = useState(false);
    const [form] = Form.useForm();

    const [data, setData] = useState()
    const [date, setDate] = useState()


    const [pagination, setPagination] = useState({
        //current: 1,
        pageSize: defaultPageSize,
        //total:200,
        showSizeChanger: false
    });

    const clearFilter = () => {
        form.setFieldsValue({
                org_structure: null,
                org_structure_name: null
            }
        )

        filterDate(moment())

        setSearch(current => {
            const {org_structure, ...rest} = current
            return rest
        })
        setSearch(current => {
            const {org_structure_name, ...rest} = current
            return rest
        })
    }

    const filterDate = (lDate, dateString) => {
        if (lDate == null) {
            setDate(moment())
            setSearch(prevState => ({
                ...prevState,
                date: moment().format('YYYY-MM-DD')
            }))
            form.setFieldsValue({
                    date: moment()
                }
            )

        } else {
            setDate(moment(lDate, 'DD.MM.YYYY'))
            setSearch(prevState => ({
                ...prevState,
                date: moment(lDate, 'DD.MM.YYYY').format('YYYY-MM-DD')
            }))
            form.setFieldsValue({
                    date: moment(lDate, 'DD.MM.YYYY')
                }
            )
        }
    }



    const Filters = () => {
        return (
            <>
                <Form
                    form={form}
                    name="advanced_search"
                    className="ant-advanced-search-form"
                    layout={"vertical"}
                    style={{marginTop: '-10pt'}}
                    onKeyDown={(e) => {
                        if (e.key === "Enter") {
                            setFilter()
                        }
                    }}
                >
                    <Row gutter={16}>
                        <Col span={8}>
                            <Form.Item
                                name='date'
                                label={t('date')}
                            >
                                <DatePicker
                                    defaultValue={date}
                                    value={date}
                                    onChange={e => filterDate(e)}
                                    format={'DD.MM.YYYY'}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={8}>
                            <Form.Item
                                name='org_structure'
                                label={t('org_structure')}
                            >
                                <DebounceSelect
                                    // mode="multiple"
                                    showSearch
                                    fetchOptions={getOrgStructureFilter}
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
                <Space
                    style={{marginTop: '-10pt', marginBottom: '20pt', width: '100%', justifyContent: 'flex-end'}}>
                    <Button icon={<ReloadOutlined/>} onClick={clearFilter}>{t('clear')}</Button>
                    <Button type={"primary"} icon={<SearchOutlined/>}
                            onClick={setFilter}>{t('search')}</Button>
                </Space>

            </>
        )
    }

    const setFilter = () => {

        if (isNullForm(form.getFieldValue('org_structure'))) {
            setSearch(current => {
                const {org_structure, ...rest} = current
                return rest
            })
        } else {
            setSearch(prevState => ({
                ...prevState,
                org_structure_name: form.getFieldValue('org_structure').label,
                org_structure: form.getFieldValue('org_structure').value,

            }))
            setCountFilters(countFilters + 1)
        }

        setSearch(current => {
            const {page, ...rest} = current
            return rest
        })
    }

    const columns = [
        {
            title: t('date'),
            dataIndex: 'date',
            render: (date) => <>{moment.utc(date).format("DD.MM.YYYY HH:mm")}</>
        },
        {
            title: t('org_structure'),
            dataIndex: 'org_structure',
            render: (name) => t(name)
        },
        {
            title: '',
            dataIndex: 'warning',
            width:'5%',
            render: (warning) => <>{warning ? <WarningTwoTone twoToneColor={"red"} style={{textAlign:'end', width:'100%'}}/> : null }</>
        },
        {
            title: "",
            width:'7%',
            render: (record) => {
                return(
                    <div className={'div-next-button'}>
                        <Link to={`${record.session_id}`} state={{path: searchParams.toString()}}>
                            <NextButton/>
                        </Link>
                    </div>
                )
            }
        }
    ]



    useEffect(() => {
        setSearchParams(search)
        countButtonFilters()
    }, [search])

    useEffect(() => {
        getData(p.get("page"), defaultPageSize)
    }, [searchParams])

    const countButtonFilters = () => {
        let cnt = 0
        if (search.date !== undefined) {
            cnt += 1
        }

        if (search.org_structure_name !== undefined) {
            cnt += 1
        }

        if (cnt === 0) {
            setCountFilters()
            setShowFilters(false)
        } else {
            setCountFilters(cnt)
            setShowFilters(true)
        }
    }

    const getData = (page, size) => {
        if (wait) {
            controller.abort()
        }
        setWait(true)

        searchParams.append('page', page)
        searchParams.append('size', size)

        getLogsMobile(controller, searchParams)
            .then(res => {
                setData(res.data.data);
                setPagination({
                    ...pagination,
                    current: res.data.page,
                    total: res.data.count,
                    pageSize: res.data.size
                })

                setWait(false);
            })
            .catch((e) => {
                if (!axios.isCancel(e)) {
                    if (e.request.status === 403) {
                        setToken(null)
                    } else {
                        setWait(false)
                        errorConnect()
                    }
                }
            });
    }

    useEffect(() => {
        window.scroll(0, 0)

        if (p.get("page") > 1) {
            setSearch(prevState => ({
                ...prevState,
                page: p.get("page")
            }))
        } else {
            setSearch(current => {
                const {page, ...rest} = current
                return rest
            })
        }
        if (p.get("size") > 1) {
            setSearch(prevState => ({
                ...prevState,
                size: p.get("size")
            }))
        } else {
            setSearch(current => {
                const {size, ...rest} = current
                return rest
            })
        }

        if (p.has('date')) {
            setDate(moment(p.get("date"),'YYYY-MM-DD'))
            setSearch(c => ({
                ...c,
                date: p.get("date")
            }))

        } else {
            setDate(moment())
            setSearch(c => ({
                ...c,
                date: moment().format('YYYY-MM-DD')
            }))
        }

        if (p.has('org_structure_name') ?? p.has('org_structure')) {
            form.setFieldsValue({
                    org_structure: p.get("org_structure_name")
                }
            )
            setSearch(prevState => ({
                ...prevState,
                org_structure_name: p.get("org_structure_name")
            }))

            setSearch(prevState => ({
                ...prevState,
                org_structure: p.get("org_structure")
            }))
        }

    }, [])


    const paginatorChange = (pagination, filters, sorter) => {
        if (pagination.current === 1) {
            setSearch(current => {
                const {page, ...rest} = current
                return rest
            })
        } else {
            setSearch(prevState => ({
                ...prevState,
                page: pagination.current
            }))
        }

        if (pagination.pageSize === defaultPageSize) {
            setSearch(current => {
                const {size, ...rest} = current
                return rest
            })
        } else {
            setSearch(prevState => ({
                ...prevState,
                size: pagination.pageSize
            }))
        }
        window.scrollTo(0, 0)
    };


    return (
        <div>
            <div className="page">
                <Space
                    style={{
                        width: '100%',
                        justifyContent: 'space-between'
                    }}>
                    <Breadcrumb
                        style={{
                            margin: '15pt 0',
                        }}
                    >
                        <Breadcrumb.Item>
                            <span className={'ant-page-header-heading-title'} style={{paddingLeft:'24px'}}>{t('logs_mobile')}</span>
                        </Breadcrumb.Item>
                    </Breadcrumb>


                </Space>

                <Collapse ghost expandIconPosition={'right'}>
                    <Collapse.Panel header={
                        <Space style={{
                            display: 'flex',
                            alignItems: 'end',
                            flexDirection: 'column',
                            flex:'auto'
                        }}>
                            <Button type={'text'} icon={<FilterOutlined/>}> {countFilters}</Button>
                        </Space>
                    }
                                    key="1"
                    >
                        <Filters/>
                    </Collapse.Panel>
                </Collapse>

                <Table
                    style={{'--cursor': "auto" }}
                    columns={columns}
                    dataSource={data}
                    rowKey="session_id"
                    loading={wait}
                    pagination={pagination}
                    size={"small"}
                    onChange={paginatorChange}
                />


            </div>
            <Outlet/>
        </div>
    )
}

export default LogsMobiles;
